import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import AppLayout from "@/components/layout/AppLayout";

// Pages are code-split: each one is fetched only when its route is opened.
const DashboardPage = lazy(() => import("@/pages/DashboardPage"));
const ClientsPage = lazy(() => import("@/pages/ClientsPage"));
const MagazinesPage = lazy(() => import("@/pages/MagazinesPage"));
const StoresPage = lazy(() => import("@/pages/StoresPage"));
const SalesPage = lazy(() => import("@/pages/SalesPage"));
const EcommercePage = lazy(() => import("@/pages/EcommercePage"));
const ReportsPage = lazy(() => import("@/pages/ReportsPage"));
const AccountsPage = lazy(() => import("@/pages/AccountsPage"));
const TreasuryPage = lazy(() => import("@/pages/TreasuryPage"));

const Loader = () => (
  <div className="flex h-screen items-center justify-center text-slate-500">
    <div className="text-sm tracking-widest uppercase">Chargement…</div>
  </div>
);

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={
            <Protected>
              <AppLayout />
            </Protected>
          }
        >
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route
            path="/clients"
            element={
              <Protected adminOnly>
                <ClientsPage />
              </Protected>
            }
          />
          <Route
            path="/accounts"
            element={
              <Protected adminOnly>
                <AccountsPage />
              </Protected>
            }
          />
          <Route path="/magazines" element={<MagazinesPage />} />
          <Route path="/stores" element={<StoresPage />} />
          <Route path="/sales" element={<SalesPage />} />
          <Route path="/ecommerce" element={<EcommercePage />} />
          <Route path="/treasury" element={<TreasuryPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
